import { useState } from 'react';

const galleryEvents = [
  {
    id: 1,
    title: 'Community Event - Rivertown',
    date: 'October 2025',
    image:
      'https://static.readdy.ai/image/538ca75b02212864d9ecfdf82df77bb0/bee9db1fabb65343173e56aa39693547.png',
  },
  {
    id: 2,
    title: 'Private Event - Birthday',
    date: 'March 2026',
    image:
      'https://public.readdy.ai/ai/img_res/f9fd088e53a63378ef40f1c9b22f8d4d.jpg',
  },
  {
    id: 3,
    title: 'Winter League',
    date: 'January - March 2026',
    image:
      'https://static.readdy.ai/image/538ca75b02212864d9ecfdf82df77bb0/5eb79af4985a526f9e9b08b96e94b272.jpeg',
  },
  {
    id: 4,
    title: 'Future events - Coming Soon!',
    date: 'April 2026',
    image:
      'https://static.readdy.ai/image/538ca75b02212864d9ecfdf82df77bb0/7b82150715816b228b639134d9c0c9e4.png',
  },
  {
    id: 5,
    title: 'Spring League - Coming Soon',
    date: 'Spring (April-May) 2026 - Register now!&nbsp;',
    image:
      'https://static.readdy.ai/image/538ca75b02212864d9ecfdf82df77bb0/6072da0a79371ce78627c03cb4d530e4.png',
  },
  {
    id: 6,
    title: 'Advertise your Corporate or Private Event here\u00a0- Book Today!\u00a0',
    date: 'Summer 2026',
    image:
      'https://static.readdy.ai/image/538ca75b02212864d9ecfdf82df77bb0/3c77ef86810cf7fba6b566df2928f60d.png',
  },
];

/**
 * @typedef {{ id: number; title: string; date: string; image: string }} GalleryEvent
 */

/**
 * GallerySection – displays a grid of past events with a lightbox modal.
 */
export default function GallerySection() {
  /** @type {[GalleryEvent | null, (e: GalleryEvent | null) => void]} */
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section id="gallery" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="inline-block text-green-600 font-semibold text-sm tracking-wider uppercase mb-3">
            Past Events
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Event Gallery
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Take a look at some of the amazing events we've been a part of across Northeast
            Florida.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryEvents.map((event) => (
            <button
              key={event.id}
              onClick={() => setSelectedImage(event)}
              className="group relative rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer text-left"
            >
              <div className="w-full h-80 overflow-hidden">
                <img
                  src={event.image}
                  alt={event.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent opacity-80 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <p className="text-green-300 text-xs font-semibold tracking-wider uppercase mb-1">
                  {event.date}
                </p>
                <h3 className="text-white font-bold text-lg leading-snug">{event.title}</h3>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div
            className="relative max-w-4xl w-full rounded-2xl overflow-hidden shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="w-full h-[500px]">
              <img
                src={selectedImage.image}
                alt={selectedImage.title}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent p-6">
              <p className="text-green-300 text-sm font-semibold tracking-wider uppercase mb-1">
                {selectedImage.date}
              </p>
              <h3 className="text-white font-bold text-2xl">{selectedImage.title}</h3>
            </div>
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute top-4 right-4 w-10 h-10 bg-black/50 hover:bg-black/70 rounded-full flex items-center justify-center cursor-pointer transition-colors"
            >
              <i className="ri-close-line text-white text-xl"></i>
            </button>
          </div>
        </div>
      )}
    </section>
  );
}
